import React from 'react';

const MainText = React.memo(({children}) => <div className="tile-square__content-block--main-text">{children}</div>);

export default MainText;
